import DataTable from "../../../components/common/data-table/data-table";
import { ASSETS_API, ASSETS_API_PREFIX } from "config-global";
import ChallengeForm from "./challenge-form";
import { CHALLENGE_COLUMNS } from "./challenge-column";
import { ChallengeSchema } from "./challenge-schema";

interface ChallengeProps {}

const Challenge: React.FC<ChallengeProps> = () => {
  return (
    <div>
      <DataTable
        tableName="Challenges"
        parentTableName="Management"
        deleteTitle="Challenges"
        mainCol="title"
        getAllLink="/api/admin/challenges?approvalStatus=APPROVED" //TODO add "api" to base rout
        getItemLink="/api/admin/challenges" //TODO add "api" to base rout
        hasEdit={true}
        hasCreate={true}
        hasDelete={true}
        updateItemLink="/api/admin/challenges" //TODO add "api" to base rout
        createItemLink="/api/admin/challenges" //TODO add "api" to base rout
        deleteRowLink="/api/admin/challenges" //TODO add "api" to base rout
        tableCols={CHALLENGE_COLUMNS}
        formSchema={ChallengeSchema()}
        FormContent={ChallengeForm}
        tableDataMapper={(rows) => {
          return rows?.map((row: any, index: number) => {
            return {
              ...row,
            };
          });
        }}
        formDataMapper={(data: any) => {
          const translationAr = data.translations.find(
            (translation: any) => translation.locale === "ar"
          );
          const translationEn = data.translations.find(
            (translation: any) => translation.locale === "en"
          );

          return {
            ...data,
            title: translationEn?.title,
            titleAr: translationAr?.title,
            description: translationEn?.description,
            descriptionAr: translationAr?.description,
            startDate: data?.startDate ? new Date(data?.startDate) : null,
            endDate: data?.endDate ? new Date(data?.endDate) : null,
            type:
              !data?.type?.value || data?.type?.value === "TEXT"
                ? "None"
                : data?.type?.value,
            challengeCategory: data?.challengeCategory?.id,
            coverImage: ASSETS_API + ASSETS_API_PREFIX + data?.coverImageUrl,
            media: ASSETS_API + ASSETS_API_PREFIX + data?.mediaUrl,
          };
        }}
        formSubmitMapper={(data: any) => {
          const formData = new FormData();
          const startDate = new Date(data.startDate);
          startDate.setHours(startDate.getHours() + 10);
          const endDate = new Date(data.endDate);
          endDate.setHours(endDate.getHours() + 10);
          formData.append("startDate", startDate.toISOString());
          formData.append("endDate", endDate.toISOString());
          formData.append("translations[0][locale]", "en");
          formData.append("translations[0][title]", data.title);
          formData.append("translations[0][description]", data.description);
          formData.append("translations[1][locale]", "ar");
          formData.append("translations[1][title]", data.titleAr);
          formData.append("translations[1][description]", data.descriptionAr);
          formData.append("published", data.published);

          if (typeof data?.coverImage === "object" && data?.coverImage) {
            formData.append("coverImage", data.coverImage);
          }

          // if (data.type === "IMAGE")
          formData.append("type", data.type ?? "IMAGE");
          data?.media && formData.append("media", data.media);
          // else formData.append("mediaUrl", data.media);

          if (!data?.id) {
            formData.append(
              "challengeCategory",
              String(data.challengeCategory)
            );
          }

          return formData;
        }}
      />
    </div>
  );
};

export default Challenge;
